import Layout from '../../internal/Layout.vue'
import electricalSafety from './index.vue'
import ElectricalSafetyManage from './ElectricalSafetyManage/ElectricalSafetyManage.vue'
import electricalSafetyPreview from './components/electricalSafetyPreview.vue'

const electricalSafetyRoutes = {
  component: Layout,
  children: [
    {
      name: 'electricalSafety',
      path: '/',
      component: electricalSafety,
      meta: {
        module: 'electricalSafety',
        requiresAuth: false,
        requiresMaster: false,
        requiresAdmin: false,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresLaboratory: false,
      },
    },
    {
      name: 'formElectricalSafety',
      path: '/formElectricalSafety',
      component: ElectricalSafetyManage,
      meta: {
        module: 'Seguranca Eletrica',
        requiresAuth: false,
        requiresMaster: false,
        requiresAdmin: false,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresLaboratory: false,
      },
    },
    {
      name: 'ElectricalSafetyPreview',
      path: '/electrical-safety-preview/:id',
      component: electricalSafetyPreview,
      meta: {
        module: 'ElectricalSafetyPreview',
        requiresAuth: false,
        requiresMaster: false,
        requiresAdmin: false,
        requiresSupervisor: false,
        requiresOperator: false,
        requiresCoordOp: false,
        requiresLaboratory: false,
      },
    },
  ],
}

export default electricalSafetyRoutes
